import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=609bcf24&scoped=true&"
import script from "./Introduction.vue?vue&type=script&lang=js&"
export * from "./Introduction.vue?vue&type=script&lang=js&"
import style0 from "./Introduction.vue?vue&type=style&index=0&id=609bcf24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609bcf24",
  null
  
)

export default component.exports